import { formatValue, lengthLimit, valuePlaceholder, showLoader, printWorkAround } from '../data-viz-helpers.js'

customElements.define('zero-amount-percent', class extends HTMLElement {
    static observedAttributes = ['data-value', 'data-label', 'data-percentage', 'data-bg', 'data-fill', 'data-help', 'data-format']

    constructor() {
        super().attachShadow({mode: 'open'})
    }

    connectedCallback() {
        this.getProps()
        this.shadowRoot.innerHTML = showLoader([this.dataset.value], this.render())
    }

    attributeChangedCallback(_, oldVal, newVal) {
        if(oldVal !== newVal) {
            this.connectedCallback()
        }
    }

    getProps() {
        this.bg = this.dataset.bg ?? 'var(--color-4-lt)'
        this.fill = this.dataset.fill ?? 'var(--color-4-dk)'
        this.fill2 = this.dataset.fill2 ?? 'var(--color-4)'
        this.format = this.dataset.format ?? ''
        this.label = this.dataset.label ?? ''
        this.value = formatValue(this.dataset.value, this.format) ?? ''
        this.percentage = parseFloat(this.dataset.percentage)
    }

    createChart(percentage, { value = '' }) {
        if (percentage < 0 || percentage > 100) {
            throw new Error('Percentage must be between 0 and 100')
        }

        return `
            <div class="wrap">
                <svg 
                    class="chart"
                    width="100" 
                    height="6"
                    viewBox="0 0 100 6"
                    preserveAspectRatio="none">

                    <rect class="bar" x="0" y="0" width="100" height="6"></rect>
                    <rect class="bar-fill" x="0" y="0" width="${percentage}" height="6"></rect>
                </svg>

                <p>${value}</p>
            </div>
        `
    }

    render() {
        return `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    align-items: center;
                    background-color: ${this.bg};
                    border-radius: var(--chart-radius);
                    container-type: inline-size;
                    display: grid;
                    height: 100%;
                    overflow: clip;
                    padding: 2em;
                    position: relative;
                    -webkit-user-select: none;
                    user-select: none;
                }

                p {
                    all: unset;
                }

                .amount {
                    display: grid;
                    justify-content: center;
                    margin-block-end: 2em;

                    .value {
                        color: ${this.fill};
                        font-size: 22cqw;
                        font-weight: 900;
                        text-align: center;
                    }

                    .label {
                        color: ${this.fill};
                        font-size: 7.5cqw;
                        font-weight: 700;
                        text-align: center;
                    }
                }

                .wrap {
                    align-items: center;
                    display: flex;
                    gap: 3cqi;

                    p {
                        color: ${this.fill};
                        font-size: 5cqi;
                        font-weight: 700;
                    }
                }

                .chart {
                    border-radius: 100vw;
                    height: auto;
                    width: 100%;

                    .bar {
                        fill: ${this.fill2};
                        opacity: 0.2;
                    }

                    .bar-fill {
                        fill: ${this.fill2};
                    }
                }
            </style>

            ${printWorkAround(this)}

            <div class="amount">
                <p data-val class="value">${valuePlaceholder(this.value)}</p>
                <p data-label class="label">${lengthLimit(this.label, 26)}</p>
            </div>

            ${this.createChart(this.percentage * 100, {
                value: formatValue(this.percentage, 'percent')
            })}
            

            ${(this.hasAttribute('data-help')) ? `<zero-help-button msg="${this.dataset.help}" color="${this.fill.replace('-dk', '')}"></zero-help-button>` : ''}
        `
    }
})